import { UserResponse, ProfileComponentType, ProfileUserResponse, PublicUserResponse } from "@authory-packages/core";

export const getTwitterProfileComponent = (user: UserResponse | ProfileUserResponse | PublicUserResponse) =>
    user.profileComponents.find((profileComponent) => profileComponent.type === ProfileComponentType.TwitterLink);
